import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Create, Add, Layers } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTableV2.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsGetAll } from 'services/WService.js';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 160 },
  { Header: 'Categoría', accessor: 'description' },
  { Header: 'Proveedor', accessor: 'provider', width: 240 },
  { Header: 'Venta desde', accessor: 'min', width: 150 },
  { Header: 'Venta hasta', accessor: 'max', width: 150 },
  { Header: 'Estado', accessor: 'state', width: 110 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

const moneda = (v) =>
  v === null || v === undefined
    ? ''
    : Number(v).toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/**
 * Mantenimiento de categorías de mueble: tramos de venta por proveedor.
 * El backend rechaza tramos que se pisen entre sí.
 */
export default WithApp(function FurnitureSalesCategory(props) {
  const classes = useStyles();

  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();
  const [categories, setCategories] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  async function loadCategories() {
    setDataLoading(true);
    let response = await wsGetAll('base/furniture-sales-category');
    setDataLoading(false);
    if (response.success) setCategories(response.data);
  }

  useEffect(() => {
    loadCategories();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      {model.open ? (
        <Modal model={model} setOpen={setOpen} showNotify={showNotify} reload={loadCategories} />
      ) : undefined}

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.BASE_FURNITURES_STORE}
              component={
                <CardIcon color="primary">
                  <Layers style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>
              Rango venta de mueble {dataLoading && <LoadingSpinner />}
            </h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="Rango venta de mueble"
              defaultWidth={950}
              columns={columns}
              data={categories.map((item, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.BASE_FURNITURES_UPDATE}>
                        <Button
                          justIcon
                          round
                          simple
                          color={props.themeContext.buttonColor}
                          onClick={() => setOpen(item)}
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions.BASE_FURNITURES_DESTROY}>
                        <ButtonDelete
                          entity="base/furniture-sales-category"
                          id={item.id}
                          reload={loadCategories}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  description: item.description,
                  provider: item.provider?.CardName || '',
                  min: moneda(item.sales_min),
                  //null significa sin tope, es la categoría más alta
                  max: item.sales_max === null ? 'Sin tope' : moneda(item.sales_max),
                  state: item.state === 'A' ? 'Activo' : 'Inactivo',
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
